import { render, staticRenderFns } from "./ResponsavelDepartamentoRow.vue?vue&type=template&id=1553b9da"
import script from "./ResponsavelDepartamentoRow.vue?vue&type=script&lang=js"
export * from "./ResponsavelDepartamentoRow.vue?vue&type=script&lang=js"
import style0 from "./ResponsavelDepartamentoRow.vue?vue&type=style&index=0&id=1553b9da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports